import { useEffect, useState } from "react"

export function HandoffOverlay() {
  const [active, setActive] = useState(false)

  useEffect(() => {
    const onEnter = () => setActive(true)
    window.addEventListener("verus:enter-terminal", onEnter)
    return () => window.removeEventListener("verus:enter-terminal", onEnter)
  }, [])

  return (
    <div id="handoff" className={active ? "active" : ""} aria-hidden="true">
      <span />
    </div>
  )
}
